import { GetNodeResponse } from '@reach/interfaces/nodes/nodes.responses';

import { ReachWorkspace } from '~app-client/workspaces/types';

export enum NodeCreationErrorKey {
	UNKNOWN = 'UNKNOWN',

	WORKSPACE_NAME_EXISTS = 'WORKSPACE_NAME_EXISTS',
	WEBSITE_URL_EXISTS = 'WEBSITE_URL_EXISTS',
	TAG_ALREADY_EXISTS = 'TAG_ALREADY_EXISTS',
}

type EmptyObject = Record<string, never>;

export interface NodeCreationErrorData {
	[NodeCreationErrorKey.WORKSPACE_NAME_EXISTS]: { name: string; existing: ReachWorkspace };
	[NodeCreationErrorKey.WEBSITE_URL_EXISTS]: { url: string; existing: GetNodeResponse };
	[NodeCreationErrorKey.TAG_ALREADY_EXISTS]: {
		name: string;
		existing: GetNodeResponse;
	};
}

export interface NodeCreationError<KEY extends NodeCreationErrorKey = NodeCreationErrorKey> {
	key: KEY;
	data: KEY extends keyof NodeCreationErrorData ? NodeCreationErrorData[KEY] : EmptyObject;
}
